module.exports = __webpack_public_path__ + "static/ssg-b296b3c7f945dca3405d8cb5d7fde8a3.png";